import { useState } from "react";
import Navbar from "./Navbar";
import { connect } from "react-redux";
import "./dashboard.css";
import { useEffect } from "react";
import { generateInitialData } from "../../store/modules/appState/actions";
import { generateDiscountedCashFlowMethod } from "../../store/modules/discountedCFM/actions";

import Typography from "@mui/material/Typography";
import BVATabs from "../../components/BVATabs/BVATabs";
import DealOffer from "./DealOffer";
import FinancialRatios from "./Financials/FinancialRatios";
import Ratios from "./Ratios/Ratios";
import QualityOfEarnings from "./QualityOfEarnings";
import Valuation from "./Valuation";
import Transactions from "./Transactions";
import Waterfall from "./Waterfall";

const FINANCIALS_TAB = "FINANCIALS_TAB";
const RATIOS_TAB = "RATIOS_TAB";
const QUALITY_OF_EARNINGS_TAB = "QUALITY_OF_EARNINGS_TAB";
const VALUATION_MODEL_TAB = "VALUATION_MODEL_TAB";
const TRANSACTIONS_TAB = "TRANSACTIONS_TAB";
const DEAL_OFFER_TAB = "DEAL_OFFER_TAB";
const WATERFALL_TAB = "WATERFALL_TAB";

const Dashboard = ({
  user,
  appState,
  generateInitialData,
  generateDiscountedCashFlowMethod,
}) => {
  const dashboardTabs = [
    { label: "Financials", value: FINANCIALS_TAB },
    { label: "Ratios", value: RATIOS_TAB },
    { label: "Quality of Earnings", value: QUALITY_OF_EARNINGS_TAB },
    { label: "Valuation", value: VALUATION_MODEL_TAB },
    { label: "Transactions", value: TRANSACTIONS_TAB },
    { label: "Deal Offer", value: DEAL_OFFER_TAB },
    { label: "Waterfall", value: WATERFALL_TAB },
  ];

  // State
  const [hideModal, setHideModal] = useState(true);
  const [currentDashboardTab, setCurrentDashboardTab] =
    useState(appState.companyData.id === "manualCompany" ? QUALITY_OF_EARNINGS_TAB : FINANCIALS_TAB);

  // Mounted
  useEffect(() => {
    //generateInitialData();
    generateDiscountedCashFlowMethod();   //This is for the financing calculator
  }, []);

  useEffect(() => {
    const handleEvent = (event) => {
      if (appState.unsaved) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    if (appState.unsaved) {
      window.addEventListener("beforeunload", handleEvent);
      // clean it up, if the dirty state changes
      return () => {
        window.removeEventListener("beforeunload", handleEvent);
      };
    }

    return () => {};
  }, [appState]);

  return appState.isError ? (
    <div>
      <Navbar />
      <Typography
        variant="h4"
        gutterBottom
        style={{ display: "flex", justifyContent: "center", margin: "30px" }}
      >
        Error. Please try again.
      </Typography>
    </div>
  ) : (
    <>
      <Navbar />

      <div className="dashboard-container">
        <div className="px-10">
          <BVATabs
            items={appState.companyData.id === "manualCompany" ? dashboardTabs.slice(2, 7) : dashboardTabs}
            value={currentDashboardTab}
            onChange={(dashboardTab) => setCurrentDashboardTab(dashboardTab)}
          />
        </div>
        <div className="mt-10 px-10 pb-10">
          {currentDashboardTab === FINANCIALS_TAB ? (
            <div>
              <FinancialRatios />
            </div>
          ) : null}

          {currentDashboardTab === RATIOS_TAB ? (
            <div>
              <Ratios />
            </div>
          ) : null}

          {currentDashboardTab === QUALITY_OF_EARNINGS_TAB ? (
            <div>
            <QualityOfEarnings companyManuality={appState.companyData.id === "manualCompany"} />
          </div>
          ) : null}

          {currentDashboardTab === VALUATION_MODEL_TAB ? (
            <div>
              <Valuation />
            </div>
          ) : null}

          {currentDashboardTab === TRANSACTIONS_TAB ? (
            <div>
              <Transactions />
            </div>
          ) : null}

          {currentDashboardTab === DEAL_OFFER_TAB ? (
            <div>
              <DealOffer />
            </div>
          ) : null}

          {currentDashboardTab === WATERFALL_TAB ? (
            <div>
              <Waterfall onAlertLinkClick={() => setCurrentDashboardTab(DEAL_OFFER_TAB)} />
            </div>
          ) : null}
        </div>
      </div>

      <div className={`modal-container ${hideModal ? "hide" : ""}`}>
        <div className="modal">
          <div className="modal-header">
            <button onClick={() => setHideModal(true)}>X</button>
          </div>
          <div className="modal-content" id="modal-content"></div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  appState: state.appState,
});

export default connect(mapStateToProps, {
  generateInitialData,
  generateDiscountedCashFlowMethod,
})(Dashboard);
